import { render, staticRenderFns } from "./Military.vue?vue&type=template&id=3b687a1d&scoped=true"
import script from "./Military.vue?vue&type=script&lang=js"
export * from "./Military.vue?vue&type=script&lang=js"
import style0 from "./Military.vue?vue&type=style&index=0&id=3b687a1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b687a1d",
  null
  
)

export default component.exports